import { addDays, addHours, endOfDay, endOfMonth, startOfDay, subDays } from 'date-fns';

export class CalendarFakeDb
{

    public static data = [
        {
            id  : 'events',
            data: [
                {
                    start    : subDays(startOfDay(new Date()), 1),
                    end      : addDays(new Date(), 1),
                    title    : 'Congresso de Pesquisas Cafeeiras',
                    allDay   : true,
                    color    : {
                        primary  : '#F44336',
                        secondary: '#FFCDD2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Poços de Caldas',
                        notes   : 'A 45ª edição do Congresso Brasileiro de Pesquisas Cafeeiras, evento realizado anualmente pela Fundação de Apoio à Tecnologia Cafeeira – Fundação ProCafé, será realizada na cidade de Poços de Caldas, Minas Gerais, no período de 29 de outubro a 1º de novembro de 2019, no salão de convenções do hotel Monreale.'
                    }
                },
                {
                    start    : startOfDay(new Date()),
                    end      : endOfDay(new Date()),
                    title    : 'Reunião Cooperativa',
                    allDay   : false,
                    color    : {
                        primary  : '#FF9800',
                        secondary: '#FFE0B2'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Paraguaçu',
                        notes   : 'Reunião de alinhamento de estoque com a cooperativa.'
                    }
                },
                {
                    start    : subDays(endOfMonth(new Date()), 3),
                    end      : addDays(endOfMonth(new Date()), 3),
                    title    : 'Apresentação de Geração de Demanda',
                    allDay   : false,
                    color    : {
                        primary  : '#1E90FF',
                        secondary: '#D1E8FF'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Alfenas',
                        notes   : 'Apresentação da Geração de Demanda para clientes de Alfenas.'
                    }
                },
                {
                    start    : addHours(startOfDay(new Date()), 2),
                    end      : new Date(),
                    title    : 'Evento de exemplo',
                    allDay   : false,
                    color    : {
                        primary  : '#673AB7',
                        secondary: '#D1C4E9'
                    },
                    resizable: {
                        beforeStart: true,
                        afterEnd   : true
                    },
                    draggable: true,
                    meta     : {
                        location: 'Franca',
                        notes   : 'Exemplo de evento programável e redimensionável.'
                    }
                }
            ]
        }
    ];
}
